'use strict';

angular.module('DoohApps').factory('DoohLazyLoad', ['DoohConfig', 'Constants', function DoohLazyLoadFactory(DoohConfig, Constants) {

    return {
        loadController: loadController,
        loadModalController: loadModalController
    }

    function loadModalController(name) {
        return loadController(name, true);
    }

    function loadController(name, isModal) {
        var controllerPath = isModal ? getModalControllerPath(name) : getControllerPath(name);
        return {
            lazy: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load({
                    name: 'DoohApps',
                    files: [controllerPath]
                });
            }]
        }
    }

    function getModalControllerPath(name) {
        return getControllerPath(name, 'angularjs/Controllers/Modals/');
    }

    function getControllerPath(name, root) {
        root = root || 'angularjs/Controllers/';
        var ext = '.js';
        var path = 'Scripts/'
        if (!DoohConfig.isDebugMode) {
            root = 'min/Controllers/';
            ext = '.min.js';
        }

        path += root + name + 'Controller' + ext + '?v=' + DoohConfig.version;
        return path;
    }    
}]);